import React from 'react';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSync } from '@fortawesome/free-solid-svg-icons';

export default (props) => {
  const clazz = classnames({
    'pcb-loading-overlay': true,
    hidden: !props.loading,
  });
  return (
    <div className={clazz}>
      <div className="spin">
        <FontAwesomeIcon icon={faSync} spin />
      </div>
    </div>
  );
};
